import { createSlice } from "@reduxjs/toolkit";

export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: {
    currentUser: { ctas: {}, features: {} },
    loggedIn: false,
  },
  reducers: {
    setUser: (state, { payload }) => {
      state.currentUser = payload;
      state.loggedIn = !!payload.email;
    },
  },
});

// SELECTORS

export const selectCurrentUserIsAdmin = (state) =>
  state.currentUser.currentUser?.admin;
export const selectCurrentUserId = (state) => state.currentUser.currentUser?.id;
export const selectIsLoggedIn = (state) => state.currentUser.loggedIn;
export const selectCurrentUser = (state) => state.currentUser.currentUser;
export const selectCTAs = (state) => state.currentUser.currentUser.ctas;
export const selectUserFeatures = (state) =>
  state.currentUser.currentUser.features || {};

// ACTIONS

export const { setUser } = currentUserSlice.actions;

export default currentUserSlice.reducer;
